import styled from 'styled-components'

const InputHint = styled.div`
  color: #bbbbbb;
  font-size: 11px;
  height: 0;
  position: relative;
`
export default InputHint



// WEBPACK FOOTER //
// ./src/components/typography/InputHint.js